import { render, staticRenderFns } from "./PCI.vue?vue&type=template&id=3fd7af8b&scoped=true"
import script from "./PCI.vue?vue&type=script&lang=js"
export * from "./PCI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd7af8b",
  null
  
)

export default component.exports